import React from "react";
import img1 from "../../assets/ingridients-images/Dicorextablet/neem.webp";
import img2 from "../../assets/ingridients-images/Dicorextablet/shilajit.webp";
import img3 from "../../assets/ingridients-images/Dicorextablet/triphala.webp";
import img4 from "../../assets/ingridients-images/Dicorextablet/vijaysar.webp";
import img5 from "../../assets/ingridients-images/Dicorextablet/aloe.webp";
import img6 from "../../assets/ingridients-images/Dicorextablet/chirata.webp";

const data = [
  {
    title: "Neem",
    img: img1,
    text: "Promotes cartilage health and flexibility",
  },
  {
    title: "Shilajit",
    img: img2,
    text: "Soothes discomfort & aids recovery",
  },
  {
    title: "Triphala",
    img: img3,
    text: "Supports joint comfort and inflammation balance",
  },
   {
    title: "Vijaysar",
    img: img4,
    text: "Imporves flexibility & joint health",
  },
   {
    title: "Aloe Vera",
    img: img5,
    text: "Enhances nutrient absorption",
  },
   {
    title: "Chirata",
    img: img6,
    text: "Promotes comfort",
  },

];

const DiacorexTabletIngredients = () => {
  return (
    <section className="ingredients">
      <h2 className="ingredients-title">
        Key Ingredients for Diacorex Tablet
      </h2>

      <div className="ingredients-grid">
        {data.map((item, index) => (
          <div className="ingredient-card" key={index}>
            <div className="pill">{item.title}</div>

            <div className="image-circle">
              <img src={item.img} alt={item.title} />
            </div>

            <p>{item.text}</p>
            <div className="card-shadow"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DiacorexTabletIngredients;
